import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.checknone');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-checknone',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.checknone/view.scss */
/* src/app/component.checknone/view.scss: no such file or directory */`],
})
export class ComponentChecknoneComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default ComponentChecknoneComponent;